import {
  Component,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Facility } from 'src/app/model/locations/facility';
import { DeviceService } from 'src/app/services/device.service';
import { isNullOrEmptyArray } from 'src/app/core/functions/common-functions';
import { Panel } from '@openng/optimus-ui/panel';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-associate-facilities',
  templateUrl: './contact-associate-facilities.component.html',
  styleUrls: ['./contact-associate-facilities.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Panel, ButtonDirective, TranslatePipe],
})
export class ContactAssociateFacilitiesComponent {
  private _deviceService = inject(DeviceService);

  readonly facilities = input<Facility[]>([]);
  readonly openFacilityEvent = output<any>();
  readonly openContactListEvent = output<any>();

  isMobile(): boolean {
    return this._deviceService.isMobile();
  }

  isFacilitiesEmpty(): boolean {
    return isNullOrEmptyArray(this.facilities());
  }
}
